import AccessTokenTable from './AccessTokenTable';

export default AccessTokenTable;
